import { MenuUnfoldOutlined } from "@ant-design/icons";
import React, { useContext } from "react";
import SidebarContext from "../../../contexts/sidebar";
import Controls from "../Controls";
import AppNavigation from "../AppNavigation";
import styles from "./navbar.module.css";

const Navbar = () => {
  const [sidebarState, sidebarDispatcher] = useContext(SidebarContext);

  const handleSidebarCollapseButtonClick = function () {
    sidebarDispatcher({
      type: "toggle",
    });
  };

  return (
    <div className={styles.navbar}>
      <div className={styles.toggle_button_container}>
        <MenuUnfoldOutlined
          className={` ${styles.toggle_button} ${
            sidebarState.active ? styles.toggle_button_active : ""
          }`}
          onClick={handleSidebarCollapseButtonClick}
        />
      </div>
      <AppNavigation />

      <div className={styles.controls_container}>
        <Controls />
      </div>
    </div>
  );
};

export default Navbar;
